import { irwin } from 'config'
import { client } from './client.js'
import Jsona, { SwitchCaseJsonMapper } from 'jsona'
import { toSnake, toCamel } from 'change-object-case'

const deserializer = new Jsona({
  jsonPropertiesMapper: new SwitchCaseJsonMapper({ switchChar: '_' }),
})

async function fetchCustomerUploadInstructions(customerId) {
  const response = await client().get('v2/customer_upload_instructions', {
    params: { customer_id: customerId },
  })

  return deserializer.deserialize(response)
}

async function createCustomerUploadInstruction(params) {
  const { id, ...rest } = params
  const response = await client().post(
    `v2/customer_upload_instructions`,
    toSnake(rest, { recursive: true, arrayRecursive: true }),
  )

  return deserializer.deserialize(response)
}

async function updateCustomerUploadInstruction(params) {
  const { id, customerId, ...rest } = params

  const response = await client().put(
    `v2/customer_upload_instructions/${params.id}`,
    toSnake(rest, { recursive: true, arrayRecursive: true }),
  )

  return deserializer.deserialize(response)
}

async function upsertCustomerUploadInstruction(params) {
  return !!params.id
    ? updateCustomerUploadInstruction(params)
    : createCustomerUploadInstruction(params)
}

async function deleteCustomerUploadInstruction(id) {
  return await client().delete(`v2/customer_upload_instructions/${id}`)
}

async function downloadCustomerUploadInstruction(id, filePath) {
  const response = await client().get(`v2/customer_upload_instructions/${id}/download`, {
    params: { file_path: toSnake(filePath) },
  })

  return toCamel(response, { recursive: true })
}

function bulkDownloadCustomerUploadInstructionUrl(id) {
  const url = `${irwin.baseUrl}/v2/customer_upload_instructions/${id}/bulk_download`

  return url
}

export {
  fetchCustomerUploadInstructions,
  deleteCustomerUploadInstruction,
  upsertCustomerUploadInstruction,
  downloadCustomerUploadInstruction,
  bulkDownloadCustomerUploadInstructionUrl,
}
